import { Box, Typography } from "@mui/material";
import React from "react";
import { useDocsStore } from "../../../../store/DocsStore";

const ContentBar = ({ scrollToSection }) => {
  const { activeSelection } = useDocsStore();

  return (
    <Box
      className={"content-bar"}
      display={"flex"}
      gap={"18px"}
      width={"151px"}
      flexDirection={"column"}
      sx={{ position: "sticky", top: 20 }}
    >
      <Typography variant="body1">CONTENTS</Typography>
      <Box
        display={"flex"}
        gap={"18px"}
        width={"151px"}
        flexDirection={"column"}
      >
        <Typography
          variant="body1"
          sx={{
            lineHeight: "32px",
            cursor: "pointer",
            fontWeight: activeSelection === "section1" ? 700 : 400,
          }}
          onClick={() => scrollToSection("section1")}
        >
          Getting started
        </Typography>
        <Typography
          variant="body1"
          sx={{
            lineHeight: "32px",
            cursor: "pointer",
            fontWeight: activeSelection === "section2" ? 700 : 400,
          }}
          onClick={() => scrollToSection("section2")}
        >
          Deploying HTTP Functions
        </Typography>
        <Typography
          variant="body1"
          sx={{
            lineHeight: "32px",
            cursor: "pointer",
            fontWeight: activeSelection === "section3" ? 700 : 400,
          }}
          onClick={() => scrollToSection("section3")}
        >
          Deploying HTTPS Functions
        </Typography>
        <Typography
          variant="body1"
          sx={{
            lineHeight: "32px",
            cursor: "pointer",
            fontWeight: activeSelection === "section4" ? 700 : 400,
          }}
          onClick={() => scrollToSection("section4")}
        >
          Certificates
        </Typography>
        <Typography
          variant="body1"
          sx={{
            lineHeight: "32px",
            cursor: "pointer",
            fontWeight: activeSelection === "section5" ? 700 : 400,
          }}
          onClick={() => scrollToSection("section5")}
        >
          Applying updates
        </Typography>
        <Typography
          variant="body1"
          sx={{
            lineHeight: "32px",
            cursor: "pointer",
            fontWeight: activeSelection === "section6" ? 700 : 400,
          }}
          onClick={() => scrollToSection("section6")}
        >
          Compilation errors
        </Typography>
        <Typography
          variant="body1"
          sx={{
            lineHeight: "32px",
            cursor: "pointer",
            fontWeight: activeSelection === "section7" ? 700 : 400,
          }}
          onClick={() => scrollToSection("section7")}
        >
          Deleting functions
        </Typography>
      </Box>
    </Box>
  );
};

export default ContentBar;
